export default __webpack_public_path__ + "static/media/Screen Shot 2023-01-25 at 20.20.59.7c595394.png";